<template>
  <!-- About Start -->
  <section
    id="about"
    class="about"
  >

    <div class="about-decor">
      <div class="about-circle1">
        <img
          src="../assets/images/team1.png"
          alt="team1"
        >
      </div>
      <div class="about-circle2">
        <img
          src="../assets/images/main-banner1.png"
          alt="banner1"
        >
      </div>
    </div>
    <b-container>
      <b-row class="mb-lg-5">
        <div class="col-md-6">
          <div class="about-contain">
            <div class="w-100">
              <h2 class="title">
                Our mechanics perform<br>repairs for...
              </h2>
              <div class="row sm-mb">
                <div class="col-6">
                  <ul class="about-style">
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img
                            src="../assets/images/cogwheelsicon.png"
                            alt="easy-to-customized"
                          >
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>Mechanical Repairs</h3>
                      </div>
                    </li>

                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img
                            src="../assets/images/collisionicon.png"
                            alt="easy-to-customized"
                          >
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>Collision Repairs</h3>
                      </div>
                    </li>
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img
                            src="../assets/images/electric-caricon.png"
                            alt="easy-to-use"
                          >
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>Electrical Repairs</h3>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-6">
                  <ul class="about-style">
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img
                            src="../assets/images/painticon.png"
                            alt="Awasome-Design"
                          >
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>Rust Repairs</h3>
                      </div>
                    </li>

                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img
                            src="../assets/images/exhausticon.png"
                            alt="Awasome-Design"
                          >
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>Exhaust Repairs</h3>
                      </div>
                    </li>
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img
                            src="../assets/images/tiresicon.png"
                            alt="SEO-Friendly"
                          >
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>Rims and Tires</h3>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!--                <div class="top-margin">-->
              <!--                  <button type="button" class="btn btn-custom theme-color theme-color">view more</button>-->
              <!--                </div>-->
            </div>
          </div>
        </div>
        <div class="col-md-6 d-medium-none">
          <img
            class="w-100"
            src="../assets/images/automotive-service-advisor.png"
            alt=""
          >
          <!--                    <div class="about-right">-->
          <!--                        <div class="about-phone">-->
          <!--                            <img :src='"../assets/images/aboutus.png"' class="img-fluid" alt="aboutus">-->
          <!--                        </div>-->
          <!--                    </div>-->
        </div>
      </b-row>


    </b-container>
  </section>
  <!-- About End -->
</template>
<script>
export default {
  name: 'About',
}
</script>
<style scoped>
.title {
  line-height: 32px;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  color: #009579;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue